export { default as CostingComparison } from './page'


// WEBPACK FOOTER //
// ./src/pages/CostingComparison/index.js